import { useEffect, useState } from "react";

export interface BusinessTheme {
  businessType: string;
  organizationName: string;
  isEmployee: boolean;
  loading: boolean;
}

export function useBusinessTheme(): BusinessTheme {
  const [businessType, setBusinessType] = useState("");
  const [organizationName, setOrganizationName] = useState("");
  const [isEmployee, setIsEmployee] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);

    const business = sessionStorage.getItem("organization_name") || "";
    const type = sessionStorage.getItem("business_type") || "";
    const storedColor = sessionStorage.getItem(`background_color${business}`);
    const employeeLogin = sessionStorage.getItem("employee");

    setOrganizationName(business);
    setBusinessType(type);
    setIsEmployee(!!employeeLogin);

    // apply background color
    if (storedColor) {
      document.documentElement.style.setProperty("--color", storedColor);
    }

    // apply font family
    const fontFamily = sessionStorage.getItem(`font_family${business}`);
    if (fontFamily) {
      document.documentElement.style.setProperty("--fontfamily", fontFamily);
    }

    setLoading(false);
  }, []);

  return { businessType, organizationName, isEmployee, loading };
}
